import { Checkbox, Option, Select } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { ChangeEvent } from "react";
import { useEffect, useState } from "react";
import type { CoverTogglesData } from "../../QuoteCards/types";
import { getCoverToggleValue } from "./getCoverToggleValue";

export const CoverToggle = (props: CoverTogglesData) => {
  const {
    fieldName,
    questionText,
    value,
    options,
    toggleOnValue,
    toggleOffValue,
    selected,
    onChange,
    isLoading,
    isError,
  } = props;
  const [selectValue, setSelectValue] = useState<string>(value);
  const [checkedValue, setCheckedValue] = useState<boolean>(selected ?? false);
  const isSelect = Array.isArray(options) && options.length > 0;

  const classes = classNames("mobius-cover-toggle", {
    "--is-select": isSelect,
    "--is-checkbox": !isSelect,
  });

  useEffect(() => {
    if (isError) {
      setSelectValue(value);
      setCheckedValue(selected ?? false);
    }
  }, [isError, selectValue, setCheckedValue, value, selected]);

  const handleChange = (
    e: ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const isCheckbox = e.target.type === "checkbox";
    const toValue = getCoverToggleValue({
      inputType: e.target.type,
      checked: isCheckbox ? (e.target as HTMLInputElement).checked : undefined,
      value: e.target.value,
      toggleOnValue,
      toggleOffValue,
    });

    setSelectValue(toValue);

    if (!isLoading && onChange) {
      onChange({
        label: questionText,
        fromValue: value,
        name: fieldName,
        toValue,
      });
    }
  };

  if (isSelect) {
    return (
      <Select
        name={fieldName}
        label={questionText}
        value={selectValue}
        className={classes}
        onChange={handleChange}
        isDisabled={isLoading}
      >
        {(options || []).map(option => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    );
  }

  return (
    <Checkbox
      name={fieldName}
      label={questionText}
      value={value}
      className={classes}
      onChange={handleChange}
      defaultSelected={checkedValue}
      isDisabled={isLoading}
    />
  );
};
